import { render, staticRenderFns } from "./showInfo.vue?vue&type=template&id=0c14034b&scoped=true&"
import script from "./showInfo.vue?vue&type=script&lang=js&"
export * from "./showInfo.vue?vue&type=script&lang=js&"
import style0 from "./showInfo.vue?vue&type=style&index=0&id=0c14034b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c14034b",
  null
  
)

export default component.exports